import React from 'react';
import styled from 'styled-components';

export type BadgeVariant =
    | 'success'
    | 'warning'
    | 'info'
    | 'danger'
    | 'neutral'
    | 'primary';

interface BadgeProps {
    children: React.ReactNode;
    variant?: BadgeVariant;
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'neutral' }) => {
    return <StyledBadge $variant={variant}>{children}</StyledBadge>;
};

const StyledBadge = styled.span<{ $variant: BadgeVariant }>`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;

  ${({ $variant, theme }) => {
        switch ($variant) {
            case 'success':
                return `background:${theme.colors.successLight}30;color:${theme.colors.successDark};`;
            case 'warning':
                return `background:${theme.colors.warningLight}30;color:${theme.colors.warningDark};`;
            case 'info':
                return `background:${theme.colors.infoLight}30;color:${theme.colors.infoDark};`;
            case 'danger':
                return `background:${theme.colors.errorLight}30;color:${theme.colors.errorDark};`;
            case 'primary':
                return `background:${theme.colors.primary};color:#ffffff;`;
            default:
                return `background:${theme.colors.gray100};color:${theme.colors.gray700};`;
        }
    }}
`;
